import { render } from "./ChooseImages.vue?vue&type=template&id=1c659a65&scoped=true"
import script from "./ChooseImages.vue?vue&type=script&lang=js"
export * from "./ChooseImages.vue?vue&type=script&lang=js"

import "./ChooseImages.vue?vue&type=style&index=0&id=1c659a65&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c659a65"]])

export default __exports__